import {
  Tooltip_default
} from "./YUSNKVRT.jsx";
import {
  InfiniteScroll
} from "./TA7VMKWL.jsx";
import {
  Empty
} from "./VHZCJL4T.jsx";
import {
  emptyPlaceholder
} from "./L3SSPJS5.jsx";
import {
  PopoverWrap
} from "./KENF4KX6.jsx";
import {
  cn
} from "./O62HZC57.jsx";
import {
  useLocalization
} from "./E42DI7CC.jsx";
import {
  IconCheck,
  IconChevronDown,
  IconLoader,
  IconSearch
} from "./WHJJ2L4B.jsx";

// src/Select/Select.tsx
import { createSignal, createEffect, createMemo, For, Show } from "solid-js";
var AS_YOUR_INPUT = "as your input: ";
var Select = (props) => {
  const [options, setOptions] = createSignal([]);
  const [loading, setLoading] = createSignal(false);
  const [search, setSearch] = createSignal("");
  const [value, setValue] = createSignal();
  const { t } = useLocalization();
  const [isInputFocused, setIsInputFocused] = createSignal(false);
  const [isSelecting, setIsSelecting] = createSignal(false);
  createEffect(() => setValue(props.value));
  createEffect(() => {
    if (typeof props.options !== "function") {
      return setOptions(props.options);
    }
    setLoading(true);
    Promise.resolve(props.options()).then(setOptions).finally(() => setLoading(false));
  });
  const selectdOptions = createMemo(() => {
    const values = value();
    return options().filter((option) => {
      if (option.type === "group") return false;
      if (!Array.isArray(values)) {
        return option.value === value();
      }
      return values?.includes(option.value);
    });
  });
  const selectedLabels = () => {
    const selected = selectdOptions();
    const text = search();
    if (props.freeInput && text && selected.length === 0) {
      return text;
    }
    return selected.map((option) => option.label).join(", ");
  };
  const filterOptions = createMemo(() => {
    const text = search();
    let filtered = options();
    let hasSameOption = false;
    if (text != null) {
      filtered = options().filter((option) => {
        const lowerOption = option.label.toLowerCase();
        const lowerText = text.toLowerCase();
        if (lowerOption === lowerText) {
          hasSameOption = true;
        }
        return option.type === "group" || lowerOption.includes(lowerText);
      });
    }
    if (props.freeInput && text && !hasSameOption) {
      filtered.push({
        type: "option",
        label: `${t(AS_YOUR_INPUT)}${text}`,
        value: text
      });
    }
    return filtered;
  });
  const isTempOption = (value2) => {
    return filterOptions().filter((item) => item.type === "option" && item.value === value2).length === 1;
  };
  const handleSelect = (e, input) => {
    const isSelectTempOption = isTempOption(input);
    if (props.freeInput && typeof input === "string" && isSelectTempOption) {
      const userInput = input.replace(t(AS_YOUR_INPUT + " "), "");
      setValue(() => userInput);
      props.onChange?.(userInput, userInput);
    } else {
      let newValue;
      if (props.multiple) {
        if (input == null) {
          newValue = setValue(() => void 0);
        } else {
          const values = value() || [];
          if (values.includes(input)) {
            newValue = setValue(() => values.filter((v) => v !== input));
          } else {
            newValue = setValue(() => [...values || [], input]);
          }
          e.preventDefault();
        }
      } else {
        newValue = setValue(() => input);
      }
      props.onChange?.(newValue, input);
      setSearch("");
    }
  };
  const handleOpenOnly = (e) => {
    if (!props.filterable) return;
    const clicked = e.target;
    if (clicked.tagName !== "INPUT") return;
    const trigger = e.currentTarget;
    if (trigger.ariaExpanded === "true") {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };
  const getValue = () => {
    if (!isInputFocused()) {
      return search() || selectedLabels();
    } else {
      return search();
    }
  };
  const findOptionByValue = (searchValue) => options().find(
    (option) => option.type !== "group" && option.value === searchValue
  );
  return <PopoverWrap onOutsideClick={(e) => e.currentTarget.contains(e.relatedTarget) && e.preventDefault()}>
      <PopoverWrap.Trigger
    id={`${props.id}-button`}
    class={cn(
      "border-input-border bg-light-gray text-title-gray placeholder:text-auxiliary-text focus-within:ring-primary aria-expanded:ring-primary group relative flex w-full items-center gap-1 overflow-hidden rounded-md border px-2 py-1 text-sm outline-none focus-within:ring-1 aria-expanded:ring-1",
      props.class
    )}
    disabled={props.disabled}
    onClick={handleOpenOnly}
  >
        <Show when={props.prefix}>
          <span class="text-text-level03 select-none whitespace-nowrap">{props.prefix}:</span>
        </Show>
        <Tooltip_default disabled={!props.disabled || !props.disabledTooltip} message={props.disabledTooltip} class="w-full" align="top">
          <input
    id={`${props.id}-input`}
    autocomplete="off"
    class={cn(
      "w-full truncate bg-transparent p-1 outline-none read-only:cursor-pointer read-only:select-none disabled:cursor-not-allowed",
      props.inputClass
    )}
    value={getValue()}
    readOnly={!props.filterable}
    placeholder={props.placeholder || emptyPlaceholder}
    onFocus={() => {
      if (!props.filterable) return;
      setIsInputFocused(true);
    }}
    onBlur={(e) => {
      if (!props.filterable) return;
      const inputValue = e.target.value;
      if (!isSelecting()) {
        setIsInputFocused(false);
        if (props.freeInput && (inputValue === "" || isTempOption(inputValue)) && value() && !isTempOption(value())) {
          const selectedOption = findOptionByValue(value());
          setSearch(selectedOption?.label ?? "");
        } else {
          setSearch("");
        }
      }
    }}
    onInput={(e) => {
      const inputValue = e.target.value;
      setSearch(inputValue);
    }}
    disabled={props?.disabled}
  />
        </Tooltip_default>

        <Show when={!loading()} fallback={<IconLoader class="text-title-gray pointer-events-none size-5 animate-spin" />}>
          <IconChevronDown class="text-title-gray pointer-events-none size-5 cursor-pointer transition-transform group-aria-expanded:rotate-180" />
        </Show>
      </PopoverWrap.Trigger>
      <PopoverWrap.Content
    as="ul"
    align="start"
    class={cn(
      "thinscroll max-h-dropdown ring-partingline my-1 flex min-w-[--reference-width] flex-col gap-1 overflow-auto rounded-md bg-white p-2 text-sm shadow-md ring-1",
      props.popoverClass
    )}
  >
        <Show
    when={!loading()}
    fallback={<li>
              <IconLoader class="text-essential-colour mx-auto my-4 size-8 animate-spin" />
            </li>}
  >
          <Show when={filterOptions().length} fallback={<Empty class="mx-auto" description={props.emptyDescription} />}>
            <For each={filterOptions()}>
              {(option, index) => <Show when={option.type !== "group"} fallback={<li class="text-text-level03 px-2 py-1">{option.label}</li>}>
                  <PopoverWrap.Trigger
    id={`${props.id}-option-${index()}`}
    as="li"
    onMouseDown={() => {
      setIsSelecting(true);
    }}
    onMouseUp={() => {
      setIsSelecting(false);
      setIsInputFocused(false);
    }}
    onClick={(e) => {
      if (option?.disabled) return;
      handleSelect(e, option.value);
    }}
  >
                    <Tooltip_default
    class="w-full"
    disabled={!option?.disabledReason || !option?.disabled}
    message={option?.disabledReason}
  >
                      <Show
    when={typeof props.renderOption !== "function"}
    fallback={props.renderOption?.({
      ...option,
      selected: selectdOptions().includes(option)
    })}
  >
                        <div
    class="flex items-center gap-1 rounded-md px-3 py-2.5 transition-colors"
    {...props.multiple ? { "data-multiple": "multiselect-option" } : {}}
    classList={{
      "text-black/20 cursor-not-allowed": option?.disabled,
      "hover-allowed:hover:bg-light-pink cursor-pointer text-title-gray ": !option?.disabled
    }}
  >
                          {option.label}
                          <Show when={selectdOptions().includes(option)}>
                            <IconCheck class="text-essential-colour ml-auto size-4" />
                          </Show>
                        </div>
                      </Show>
                    </Tooltip_default>
                  </PopoverWrap.Trigger>
                </Show>}
            </For>
          </Show>
        </Show>
      </PopoverWrap.Content>
    </PopoverWrap>;
};

// src/Select/SearchSelect.tsx
import { HttpError } from "@magicdoor/errors";
import { For as For2, Show as Show2, createEffect as createEffect2, createMemo as createMemo2, createSignal as createSignal2, equalFn, on } from "solid-js";

// src/utils/strings.ts
var stringToColor = (str) => {
  const hash = Array.from(str).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const h = hash % 360 % 300 + 20;
  const s = 85 + hash % 10 + "%";
  const l = 33 + hash % 5 + "%";
  return `hsl(${h}, ${s}, ${l})`;
};

// src/Select/SearchSelect.tsx
import { debounce } from "lodash-es";
var SearchSelect = (props) => {
  const { t } = useLocalization();
  const [list, setList] = createSignal2([]);
  const [pagination, setPagination] = createSignal2();
  const [error, setError] = createSignal2();
  const [query, setQuery] = createSignal2("");
  const [selected, setSelected] = createSignal2([]);
  let inputRef;
  createEffect2(
    on(
      () => ({
        selected: props.selected,
        defaultSelected: props.defaultSelected
      }),
      (current, prev) => {
        let _selected = current.selected;
        if (!_selected && current.defaultSelected && !equalFn(current.defaultSelected, prev?.defaultSelected)) {
          _selected = current.defaultSelected;
        }
        if (_selected) {
          setSelected(Array.isArray(_selected) ? _selected : [_selected]);
        }
      }
    )
  );
  const loadInitialSelected = async (defaultSelectedIds) => {
    if (props.initialSelectedLoader && defaultSelectedIds) {
      const items = await props.initialSelectedLoader(defaultSelectedIds);
      setSelected(items);
    }
  };
  createEffect2(
    on(
      () => props.defaultSelectedIds,
      (current, prev) => {
        if (equalFn(current, prev)) return;
        const array = (Array.isArray(current) ? current : [current]).filter((item) => !!item);
        if (array && array.length) {
          loadInitialSelected(array);
        } else {
          setSelected([]);
        }
      }
    )
  );
  const isSelected = (item) => selected().some((i) => i.id === item.id);
  const ended = () => {
    const c = pagination();
    return c != null && c.totalPages <= c.page;
  };
  const renderSelected = createMemo2(() => {
    if (typeof props.renderSelected === "function") return props.renderSelected;
    const key = props.renderSelected;
    return (item) => item[key];
  });
  const errorMessage = () => {
    const err = error();
    if (err == null) return;
    if (err instanceof HttpError) {
      const msg = Object.values(err.getErrors()).flat();
      return msg.toString();
    }
    if (err instanceof Error) {
      return err.message;
    }
    return t("Operation failed, please try again later");
  };
  const handleQuery = debounce((q) => {
    if (!q || props.minimumInputLength === void 0 || q && props.minimumInputLength !== void 0 && q.length >= props.minimumInputLength) {
      setQuery(q);
      setPagination(void 0);
      setError(void 0);
      setList([]);
    }
  }, 500);
  const handleSelect = (e, item) => {
    if (e.currentTarget.ariaDisabled === "true") {
      e.preventDefault();
      return;
    }
    if (props.multiple) {
      if (!props.doNotRenderSelected) {
        if (isSelected(item)) {
          setSelected((prev) => prev.filter((i) => i.id !== item.id));
        } else {
          setSelected((prev) => [...prev, item]);
        }
      }
      props.onSelect?.(selected());
      setQuery("");
      e.preventDefault();
    } else {
      if (!props.doNotRenderSelected) {
        setSelected([item]);
      }
      props.onSelect?.(item);
      setQuery("");
    }
  };
  const handleRemove = (e, item) => {
    e.stopImmediatePropagation();
    setSelected((prev) => prev.filter((i) => i.id !== item.id));
    props.onSelect?.(selected());
  };
  const handleLoad = async () => {
    const page = (pagination()?.page || 0) + 1;
    try {
      const { items, totalPages } = await props.fetcher(query(), page);
      setPagination({ page, totalPages });
      setList(
        (prev) => [...prev, ...items].filter((i, index, self) => !props.exclude?.(i) && index === self.findIndex((t2) => t2.id === i.id))
      );
    } catch (err) {
      setError(err);
    }
  };
  const handleOpenOnly = (e) => {
    const trigger = e.currentTarget;
    inputRef.focus();
    if (trigger.ariaExpanded === "true") {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };
  return <PopoverWrap
    onOpenChange={(open) => open || handleQuery("")}
    onOutsideClick={(e) => e.currentTarget.contains(e.relatedTarget) && e.preventDefault()}
  >
      <PopoverWrap.Trigger
    id={`${props.id}`}
    class="bg-inputbox-bg text-title-gray placeholder:text-auxiliary-text focus-within:ring-primary aria-expanded:ring-primary relative flex w-full flex-wrap items-center gap-2 rounded-md border px-2.5 py-0.5 text-sm outline-none focus-within:ring-1 aria-expanded:ring-1"
    onClick={handleOpenOnly}
  >
        <Show2 when={props.prefix}>
          <span class="text-text-level03 select-none whitespace-nowrap">{props.prefix}: </span>
        </Show2>
        <Show2 when={selected().length > 0}>
          <div class="flex select-none flex-wrap gap-1 py-1">
            <For2 each={selected()}>
              {(item, index) => {
    const label = renderSelected()(item);
    return <button
      id={`${props.id}-${index()}-remove-btn`}
      type="button"
      class="bg-current-alpha flex items-center gap-1 rounded-md px-1.5 text-sm text-[--c] after:text-base after:content-['×']"
      style={{
        "--c": stringToColor(typeof label === "string" ? label : item.id)
      }}
      onClick={(e) => handleRemove(e, item)}
      title={t("Remove select")}
    >
                    {renderSelected()(item)}
                  </button>;
  }}
            </For2>
          </div>
        </Show2>
        <input
    id={`${props.id}-input`}
    autocomplete="off"
    ref={inputRef}
    class="flex-basis-[80px] flex-1 truncate bg-transparent px-1 py-1.5 outline-none"
    value={query()}
    onInput={(e) => handleQuery(e.currentTarget.value)}
    onKeyUp={(e) => {
      if (query() || e.key !== "Backspace" || selected()?.length === 0) return;
      props.onSelect?.(setSelected((prev) => prev.slice(0, -1)));
    }}
    placeholder={!props.multiple && selected().length !== 0 ? void 0 : props.placeholder ?? t("Search")}
  />
        <IconSearch class="text-text-level03 pointer-events-none absolute bottom-2.5 right-3 size-4" />
      </PopoverWrap.Trigger>
      <PopoverWrap.Content
    aria-disable-swipe
    class="thinscroll max-h-dropdown text-text-level02 my-1 min-w-[--reference-width] space-y-0.5 overflow-auto overscroll-contain rounded-md border border-gray-300 bg-white p-2 py-3 text-sm shadow-lg"
    as={InfiniteScroll}
    threshold={100}
    ended={error() != null || ended()}
    endMessage={errorMessage()}
    onReachEnd={handleLoad}
  >
        <For2 each={list()}>
          {(item, index) => {
    const disabledLabel = props.disabledItem?.(item);
    return <PopoverWrap.Trigger
      id={`${props.id}-item-${index()}`}
      as="li"
      class="aria-checked:bg-light-pink hover-allowed:hover:bg-light-pink flex cursor-pointer items-center justify-between rounded-md px-3 py-2.5 transition-colors aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
      onClick={(e) => handleSelect(e, item)}
      aria-checked={isSelected(item)}
      aria-disabled={!!disabledLabel}
    >
                {props.renderItem(item, { disabledLabel })}
                <Show2 when={isSelected(item)}>
                  <IconCheck class="text-primary size-5" />
                </Show2>
              </PopoverWrap.Trigger>;
  }}
        </For2>
      </PopoverWrap.Content>
    </PopoverWrap>;
};

export {
  Select,
  stringToColor,
  SearchSelect
};
